// Template exports (POST /organization/reports/export): the first rows to
// show on screen, and the whole file, built on the server.

export const previewTemplate = (send, template, filter) =>
  send("post")({ url: "/organization/reports/export", data: { template, filter, preview: true } }).then((res) => res.data);

/** Build the file and save it: the server answers with a short-lived link. */
export const downloadTemplate = async (send, template, filter, format) => {
  const res = await send("post")({ url: "/organization/reports/export", data: { template, filter, format } });
  const { url, filename } = res.data ?? {};
  if (!url) throw new Error("The export did not come back");
  // the link is served as an attachment, so following it saves the file
  const link = document.createElement("a");
  link.href = url;
  link.download = filename ?? "";
  link.rel = "noopener";
  document.body.appendChild(link);
  link.click();
  link.remove();
  return res.data;
};
